import { Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import image from '../../../../images/game-fact/coup franc.png'
import { isFeuilleDeMatchFull } from '../../utils/feuilleMatch.js'
import { EMPTY_PLAYER } from '../../utils/helpers.js'
import { GAME_FACT_TRANSFORMATION } from '../constants.js'
import TextCustom from '../generic/textCustom.js'
import { useGameFact } from '../useGameFact.js'
import { getVisualTimer } from '../../sports/rules.js'

const RecapTransformation = ({state, match, onChangeText, onChangeTitle, inHistory}) => {
    const {team, timer, transformer, transformSucced, period} = state

    const [img] = useGameFact({type : GAME_FACT_TRANSFORMATION})

    const {homeHolders, homeSubstitutes, awayHolders, awaySubstitutes, homeTeam, awayTeam} = match

    let allPlayers = isFeuilleDeMatchFull(match) ? [...homeHolders, ...homeSubstitutes, ...awayHolders, ...awaySubstitutes] : [...match.homeTeam.players, ...match.awayTeam.players]

    let transformerPlayer = allPlayers.find(p => p._id === transformer) ?? EMPTY_PLAYER

    let teamSelected = [homeTeam, awayTeam].find(t => t._id === team)

    const actualPeriod = period ??  match.period

    // Gestion du text
    useEffect(() => {
        if(!state.text || state.edited){
            const monText = 'Transformation '+(transformSucced ? 'réussie' : 'ratée')+' par '+transformerPlayer.lastname+'!'
            
            if(!inHistory)
                onChangeText && onChangeText(monText)
        }

        if(!state.title || state.edited){
            const monTitle = 'TRANSFORMATION'
            
            if(!inHistory){
                onChangeTitle && onChangeTitle(monTitle)
            }
                
        }
    }, [])

    return (
        <div style={{color : inHistory ? 'black' : 'white'}}>
            <img src={img} width={150}/>
            <Typography>Equipe : {teamSelected.name}</Typography>
            <Typography>Joueur : {transformerPlayer.lastname} ({transformSucced ? 'Réussie' : 'Ratée'})</Typography>
            {(timer !== 0 || period !== 0) && <Typography>Minute : {getVisualTimer(actualPeriod, timer, match.discipline)}</Typography>}

            {state.title && <TextCustom initialText={state.title} onChangeText={onChangeTitle} label={'Titre'}/>}
            {state.text && <TextCustom initialText={state.text} onChangeText={onChangeText} label={'Texte'}/>}
        </div>
    )
}

export default RecapTransformation